// Money display helpers — group an integer amount with spaces (UZS, no decimals):
//   "10000" -> "10 000",  "4000" -> "4 000".
// The mask is display-only: the stored/submitted value stays a plain digit string.

/** Strip everything except digits (drops spaces, separators, letters, signs). */
export function digitsOnly(input: string): string {
  return input.replace(/\D/g, "");
}

/**
 * Group a digit string into space-separated thousands. Empty input -> "".
 * Input is expected to be digits only (run through digitsOnly first when unsure).
 */
export function groupThousands(digits: string): string {
  if (!digits) return "";
  return digits.replace(/\B(?=(\d{3})+(?!\d))/g, " ");
}
